(() => {
  setTimeout(() => {
  function debounce(fn, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }
  
  const handleDomChange = debounce(() => {
    BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
  }, 300);
  
  const targetNode = document.querySelector('.usf-sr-container');
  
  if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
      handleDomChange();
    });
  
    observer.observe(targetNode, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  }
}, 2000);

})();